module.exports = __webpack_public_path__ + "static/media/60.226ed3a.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/60.wav
// module id = 1yUm
// module chunks = 0